import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import kav from "../../assets/button-page/bttn-kav.png";
import com from "../../assets/button-page/bttn-com.png";
import React from "react";
import "./buttoncta.scss";

const buttoncta = () => {
  return (
    <div className="buttoncta">
      <div className="container-cta">
        <a href="/residentials/#kavling">
          <div className="cta1">
            <div className="content">
              <FontAwesomeIcon
                icon={faArrowAltCircleRight}
                size="2x"
                color="white"
              />
              <div className="headercta">Kavling Residential</div>
              <div className="deskcta">Cicilan Start From 11 Juta/Bulan</div>
            </div>

            <img src={kav} alt="btnkav" />
          </div>
        </a>
        <a href="/commercials">
          <div className="cta2">
            <div className="content">
              <FontAwesomeIcon
                icon={faArrowAltCircleRight}
                size="2x"
                color="white"
              />
              <div className="headercta">Ruko Commercials</div>
              <div className="deskcta">Tanpa DP, Cicilan 10 Juta/Bulan</div>
            </div>
            <img src={com} alt="btnkav" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default buttoncta;
